import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import logoSrc from '../assets/logo.png';
import { useLanguage } from '../i18n/LanguageContext';

const LogoContainer = styled(Link)`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

const LogoImage = styled.img`
  height: 80px;
  width: auto;
  display: block;
  filter: ${({ $variant }) => ($variant === 'light' ? 'brightness(1.15)' : 'none')};

  @media (max-width: 600px) {
    height: 55px;
  }
`;

const Logo = ({ className, variant = 'default' }) => {
  const { t } = useLanguage();
  return (
    <LogoContainer to="/" className={className} aria-label={t('logo.ariaLabel')}>
      <LogoImage src={logoSrc} alt={t('logo.alt')} $variant={variant} />
    </LogoContainer>
  );
};

export default Logo;